import { useTranslation } from 'react-i18next';
import { useClientContext } from '../../ClientContext';
import { clientSpending, useFirmClient } from '../../FirmClient';
import { RecurringFrequency } from '../../generated/graphql';
import { IncomeAndSpendingButton } from './IncomeAndSpendingButton';

export const AnnualSpendingButton = ({ linkTo }: { linkTo: string }) => {
  const { t: tCommon } = useTranslation('common');
  const { firmID, clientID } = useClientContext();
  const { firmClient, firmClientQuery } = useFirmClient({ firmID, firmClientID: clientID });

  if (firmClientQuery.isLoading)
    return <div className="animate-pulse bg-darkMode-gray-medium/20  rounded-2xl h-20 w-full" />;

  return (
    <IncomeAndSpendingButton
      value={clientSpending(firmClient, { frequency: RecurringFrequency.Annually }).monetaryAmount}
      label={tCommon('annual-spending-button-title')}
      to={linkTo}
      linkState={{ viewIndex: 1 }}
    />
  );
};
